import { api } from './queryInterceptors';

import type { AxiosResponse } from 'axios';
import type { PaginatedResponse } from '@/types/api';
import type { Answer } from '@/types/respondent';

/**
 * Retrieve a respondent's non-deleted and non-ignored answers from the API.
 *
 * @param respondentId - The ID of the respondent for whom to fetch answers.
 * @returns A Promise resolving to the Axios response containing the paginated list of answers.
 */
export async function answersGetQuery(
  respondentId: string,
): Promise<AxiosResponse<PaginatedResponse<Answer>>> {
  const requestOptions = {
    method: 'GET',
    url: `/answers/`,
    params: {
      deletedAtIsNull: true,
      ignoredAtIsNull: true,
      limit: 5000,
      respondent: respondentId
    }
  };

  return api(requestOptions);
}

/**
 * Post a list of answers to the API.
 *
 * @param answersToPost - The list of answers to be saved via the API.
 * @returns A Promise resolving to the Axios response containing the list of posted answers.
 */
export async function answersPostQuery(
  answersToPost: Answer[]
): Promise<AxiosResponse<Answer[]>> {
  const requestOptions = {
    method: 'POST',
    url: `/answers/`,
    data: answersToPost
  };

  return api(requestOptions);
}